import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateContactoRequest  extends CreateKeyValueRequest{
  idPersona!: number;
  idTipoContacto!: number;
  valorContacto?: string;
  preferido!: boolean;
  empresaAsociada?: string;
  fechaUltimoContacto?: string;
  tipoRelacion?: string;
  fuenteContacto?: string;
  notasSeguimiento?: string;
  estadoContacto?: string;
  categoriasEtiquetas?: string;
  historialInteracciones?: string;
  preferenciasContacto?: string;
}
